<template>
  <v-expansion-panel>
    <v-expansion-panel-header v-slot="{ open }">
      <v-row no-gutters>
        <v-col cols="4" class="blue--text text--darken-1">
          Fiche Signalement / Visite Preinstallation
        </v-col>
        <v-col cols="8" class="text--secondary">
          <v-fade-transition leave-absolute>
            <span v-if="open" key="0"> Editer la fiche puis sauvegarder </span>
            <span v-else key="1">
              <div v-if="ficheSignalement.account">
                {{ ficheSignalement.account.name }}
              </div>
              <div v-if="ficheSignalement.laverie">
                / {{ ficheSignalement.laverie.name }}
              </div>
            </span>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="ficheSignalement.type"
            :items="signalementTypes"
            label="Type"
            @update:model-value="onChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le type de la fiche
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.type" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="ficheSignalement.account"
            :items="accounts"
            :item-text="'name'"
            return-object
            label="Siège"
            @update:model-value="onAccountChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le compte siège
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.account" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="ficheSignalement.laverie"
            :items="laveries"
            :item-text="'name'"
            return-object
            label="Laverie"
            @update:model-value="onChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la laverie
        </v-col>
      </v-row>
      <v-row
        v-if="ficheSignalement.laverie && ficheSignalement.laverie.address"
        no-gutters
      >
        <v-spacer></v-spacer>
        <v-col cols="1">
          <v-text-field
            name="numero"
            hint="Le numéro dans la rue"
            v-model="ficheSignalement.laverie.address.numero"
            class="input-group--focused"
            label="Numero"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5">
          <v-text-field
            name="rue"
            hint="Le nom de la rue"
            v-model="ficheSignalement.laverie.address.rue"
            class="input-group--focused"
            label="Rue"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Changez l'adresse si nécessaire
        </v-col>
      </v-row>
      <v-row
        v-if="ficheSignalement.laverie && ficheSignalement.laverie.address"
        no-gutters
      >
        <v-spacer></v-spacer>
        <v-col cols="1">
          <v-text-field
            name="codepostale"
            hint="Le code postale de la ville"
            v-model="ficheSignalement.laverie.address.codepostale"
            class="input-group--focused"
            label="Code Postale"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5">
          <v-text-field
            name="ville"
            hint="Le nom de la ville"
            v-model="ficheSignalement.laverie.address.ville"
            class="input-group--focused"
            label="Ville"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.laverie" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-menu
            :close-on-content-click="true"
            v-model="dateMenu"
            transition="v-scale-transition"
            offset-y
            :nudge-left="40"
            max-width="290px"
          >
            <template v-slot:activator="{ props }">
              <v-text-field
                v-bind="props"
                label="Date Livraison"
                v-model="ficheSignalement.visitDate"
                prepend-icon="mdi-calendar"
                readonly
                @blur="onBlur"
              ></v-text-field>
            </template>
            <v-date-picker v-model="ficheSignalement.visitDate" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la date de la visite
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.visitDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-text-field
            name="etage"
            v-model="ficheSignalement.accessibility.etage"
            class="input-group--focused"
            label="Etage"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="ascenseur"
            v-model="ficheSignalement.accessibility.ascenseur"
            class="input-group--focused"
            label="Ascenseur"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="escalier"
            v-model="ficheSignalement.accessibility.escalier"
            class="input-group--focused"
            label="Escalier"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Détaillez l'accessibilité
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.visitDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-text-field
            name="codePorte"
            v-model="ficheSignalement.accessibility.codePorte"
            class="input-group--focused"
            label="Code Porte"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="parkingPrive"
            v-model="ficheSignalement.accessibility.parking"
            class="input-group--focused"
            label="Parking Privé"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="cle"
            v-model="ficheSignalement.accessibility.key"
            class="input-group--focused"
            label="Clé"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row
        v-if="
          ficheSignalement.visitDate &&
          ficheSignalement.type == signalementTypeSignalementTechnicien
        "
        no-gutters
      >
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="motifSignalement"
            v-model="ficheSignalement.motifSignalement"
            class="input-group--focused"
            label="Motif Signalement"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Précisez le motif de signalement
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.visitDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="ficheSignalement.visitedBy"
            :items="users"
            :item-text="(item) => `${item.name} ${item.lastname}`"
            return-object
            label="Visite faite par"
            @update:model-value="onChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le technicien
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.visitedBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field
            name="responsableSiteNom"
            hint="Nom du responsable site"
            v-model="ficheSignalement.manager.lastname"
            class="input-group--focused"
            label="Nom"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            name="responsableSitePrenom"
            hint="Prénom du responsable site"
            v-model="ficheSignalement.manager.name"
            class="input-group--focused"
            label="Prénom"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Renseignez le responsable site
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.visitedBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field
            name="responsableSiteTel"
            hint="Téléphone du responsable site"
            v-model="ficheSignalement.manager.telephone"
            class="input-group--focused"
            label="Téléphone"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            name="responsableSiteMobile"
            hint="Mobile du responsable site"
            v-model="ficheSignalement.manager.mobile"
            class="input-group--focused"
            label="Mobile"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.visitedBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="responsableSiteEmail"
            hint="Courriel du responsable site"
            v-model="ficheSignalement.manager.email"
            class="input-group--focused"
            label="Courriel"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.visitedBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field
            name="contactTechNom"
            hint="Nom du contact technique"
            v-model="ficheSignalement.techUser.lastname"
            class="input-group--focused"
            label="Nom"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            name="contactTechPrenom"
            hint="Prénom du contact technique"
            v-model="ficheSignalement.techUser.name"
            class="input-group--focused"
            label="Prénom"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Renseignez le contact technique
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.visitedBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field
            name="contactTechTel"
            hint="Téléphone du contact technique"
            v-model="ficheSignalement.techUser.telephone"
            class="input-group--focused"
            label="Téléphone"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            name="contactTechMobile"
            hint="Mobile du contact technique"
            v-model="ficheSignalement.techUser.mobile"
            class="input-group--focused"
            label="Mobile"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.visitedBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="contactTechEmail"
            hint="Courriel du contact technique"
            v-model="ficheSignalement.techUser.email"
            class="input-group--focused"
            label="Courriel"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onCancel" text color="red"> Cancel </v-btn>
        <generate-doc-btn
          :filePath="ficheSignalementTemplatePath"
          :fileName="ficheSignalementFileName"
          :dataSet="ficheSignalementGen"
          >Save</generate-doc-btn
        >
      </v-card-actions>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import GenerateDocBtn from "@/components/GenerateDocBtn.vue";
import type { User } from "@/types";
import type { FicheSignalement } from "@/types";
import { FicheSignalementGen, SignalementType } from "@/types";
import { flattenFicheSignalement } from "@/types";
import type { Accessibility } from "@/types";
import type { Account } from "@/types";
import type { Laverie } from "@/types";
import { getLaveriesByAccountId } from "@/utils/laverie-api";

// Props
interface Props {
  accounts: Account[];
  users: User[];
}

const props = defineProps<Props>();

// Reactive state
const dateMenu = ref(false);
const ficheSignalement = ref<FicheSignalement>({
  manager: {} as User,
  techUser: {} as User,
  accessibility: {} as Accessibility,
} as FicheSignalement);
const ficheSignalementGen = ref<FicheSignalementGen>(new FicheSignalementGen());
const laveries = ref<Laverie[]>([]);

// Computed properties
const signalementTypeSignalementTechnicien = computed(
  () => SignalementType.Signalement_Technicien
);

const signalementTypes = computed(() => Object.values(SignalementType));

const ficheSignalementTemplatePath = computed(() => {
  return "templates/FicheDeSignalementTemplate.docx";
});

const ficheSignalementFileName = computed(() => {
  if (ficheSignalement.value.laverie?.name) {
    return `FicheDeSignalement_${ficheSignalement.value.laverie.name}`;
  }
  return "FicheDeSignalement";
});

// Methods
const onAccountChange = async (selectedAccount: Account) => {
  ficheSignalement.value.account = selectedAccount;
  // Reset selected laverie
  ficheSignalement.value.laverie = null;
  // Clear previous data
  laveries.value = [];
  await fetchLaveries(selectedAccount.id);
  // Regenerate document data
  ficheSignalementGen.value = flattenFicheSignalement(ficheSignalement.value);
};

const fetchLaveries = async (accountId: string) => {
  try {
    laveries.value = await getLaveriesByAccountId(accountId);
  } catch (error) {
    console.error("Error fetching laveries:", error);
    laveries.value = [];
  }
};

const onChange = () => {
  onBlur();
};

const onBlur = () => {
  ficheSignalementGen.value = flattenFicheSignalement(ficheSignalement.value);
};

const onCancel = () => {
  // Clear form
  ficheSignalement.value = {
    manager: {} as User,
    techUser: {} as User,
    accessibility: {} as Accessibility,
  } as FicheSignalement;
  ficheSignalementGen.value = {} as FicheSignalementGen;
  laveries.value = [];
  dateMenu.value = false;
};
</script>
